import { InfoCircleOutlined } from '@ant-design/icons';
import { Flex } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useTranslation } from 'react-i18next';
import { CropTable, InfoContainer, Paragraph } from './abiotic-info-modal.styles';

interface CropStressData {
  key: string;
  crop: string;
  frostStress: string;
  heatStress: string;
}

export const AbioticInfoModal = () => {
  const { t } = useTranslation();

  const columns: ColumnsType<CropStressData> = [
    {
      title: '',
      dataIndex: 'crop',
      key: 'crop'
    },
    {
      title: t('pages.regional_overview.abiotic_stress.info_modal.frost_stress'),
      dataIndex: 'frostStress',
      key: 'frostStress'
    },
    {
      title: t('pages.regional_overview.abiotic_stress.info_modal.heat_stress'),
      dataIndex: 'heatStress',
      key: 'heatStress'
    }
  ];

  const data: CropStressData[] = [
    {
      key: '1',
      crop: t('general.crops.winter_wheat'),
      frostStress: t('pages.regional_overview.abiotic_stress.info_modal.winter_wheat.frost_phase'),
      heatStress: t('pages.regional_overview.abiotic_stress.info_modal.winter_wheat.heat_phase')
    },
    {
      key: '2',
      crop: t('general.crops.winter_barley'),
      frostStress: t('pages.regional_overview.abiotic_stress.info_modal.winter_barley.frost_phase'),
      heatStress: t('pages.regional_overview.abiotic_stress.info_modal.winter_barley.heat_phase')
    },
    {
      key: '3',
      crop: t('general.crops.potato'),
      frostStress: t('pages.regional_overview.abiotic_stress.info_modal.potato.frost_phase'),
      heatStress: t('pages.regional_overview.abiotic_stress.info_modal.potato.heat_phase')
    },
    {
      key: '4',
      crop: t('general.crops.corn'),
      frostStress: t('pages.regional_overview.abiotic_stress.info_modal.corn.frost_phase'),
      heatStress: t('pages.regional_overview.abiotic_stress.info_modal.corn.heat_phase')
    },
    {
      key: '5',
      crop: t('general.crops.sunflower'),
      frostStress: t('pages.regional_overview.abiotic_stress.info_modal.sunflower.frost_phase'),
      heatStress: t('pages.regional_overview.abiotic_stress.info_modal.sunflower.heat_phase')
    },
    {
      key: '6',
      crop: t('general.crops.wosr'),
      frostStress: t('pages.regional_overview.abiotic_stress.info_modal.wosr.frost_phase'),
      heatStress: t('pages.regional_overview.abiotic_stress.info_modal.wosr.heat_phase')
    },
    {
      key: '7',
      crop: t('general.crops.grape'),
      frostStress: t('pages.regional_overview.abiotic_stress.info_modal.grape.frost_phase'),
      heatStress: t('pages.regional_overview.abiotic_stress.info_modal.grape.heat_phase')
    }
  ];

  return (
    <InfoContainer>
      <Flex vertical gap={12}>
        <section>
          <Paragraph>
            <strong>{`${t('pages.regional_overview.abiotic_stress.info_modal.protector')} `}</strong>
            {t('pages.regional_overview.abiotic_stress.info_modal.description_1')}
          </Paragraph>
          <Paragraph>
            <strong>{`${t('pages.regional_overview.abiotic_stress.info_modal.important')}: `}</strong>
            {t('pages.regional_overview.abiotic_stress.info_modal.description_2')}
          </Paragraph>
        </section>

        <section>
          <Flex align='center' gap={4} style={{ marginBottom: 16 }}>
            <InfoCircleOutlined style={{ fontSize: 18 }} />
            <Paragraph strong style={{ margin: 0 }}>
              {t('pages.regional_overview.abiotic_stress.info_modal.how_to_interpret')}
            </Paragraph>
          </Flex>

          <CropTable<CropStressData> columns={columns} dataSource={data} pagination={false} size='small' bordered />

          <Paragraph>{t('pages.regional_overview.abiotic_stress.info_modal.interpretation_description')}</Paragraph>
        </section>
      </Flex>
    </InfoContainer>
  );
};
